import { render, staticRenderFns } from "./rightsManagement.vue?vue&type=template&id=8a90d1b2&scoped=true&"
import script from "./rightsManagement.vue?vue&type=script&lang=js&"
export * from "./rightsManagement.vue?vue&type=script&lang=js&"
import style0 from "./rightsManagement.vue?vue&type=style&index=0&id=8a90d1b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a90d1b2",
  null
  
)

export default component.exports